import { InvoiceTextClockOutlineIcon } from './InvoiceTextClockOutlineIcon';

/**
 * author: Jeff Anders
 * id 957ED765-1CC2-4C07-959B-065465917872
 * name invoice-text-clock-outline
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-text-clock-outline.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceTextScheduledOutlineIcon = InvoiceTextClockOutlineIcon;
export default InvoiceTextScheduledOutlineIcon